export default __webpack_public_path__ + "hall-of-fame-desktop-cn-ebd971f2369d8671dbc1ef20aae299b7.png";